export function formatDate(dateStr) {
    if (!dateStr)
        return '';
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime()))
        return dateStr;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
/** "$2.5M", "$600k", "$10,000": a raise as the lists show it. */
export function formatDollars(amount) {
    if (amount >= 1_000_000)
        return `$${amount / 1_000_000}M`;
    if (amount >= 1_000)
        return `$${amount / 1_000}k`;
    return `$${amount.toLocaleString('en-GB')}`;
}
export function formatAmount(amount) {
    if (!amount)
        return '';
    const num = Number(amount);
    if (Number.isNaN(num))
        return amount;
    if (amount.startsWith('$'))
        return amount;
    return formatDollars(num);
}
//# sourceMappingURL=format.js.map